module.exports = __webpack_public_path__ + "static/media/Barriers.2137a9ea.png";